var SENTRY_RELEASE;SENTRY_RELEASE={name: "Evoluno", version: "1.12.5"};